import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useRequest } from 'ahooks'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { getRet00cdTree } from 'components/common/services/ret00cds'
import Ret00cEditorPage from './Ret00cEditorPage'
import { createRet00c } from 'components/common/services/ret00cs'
import { useRet00cGroupFilter } from './useRet00cGroupFilter'

function New(): JSX.Element {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { reloadTree } = useRet00cGroupFilter()
  const [urlParamsReady, setUrlParamsReady] = useState(false)
  const [initialRecord, setInitialRecord] = useState<any>({
    http_method: 'POST',
    status: 'enabled',
  })
  const { data } = useRequest(getRet00cdTree)
  const groupOptions = useMemo(() => (data as any)?.data?.data?.items || [], [data])

  useEffect(() => {
    if (urlParamsReady) return
    const ret00cdId = searchParams.get('ret00cd_id')
    if (ret00cdId) {
      const numeric = Number(ret00cdId)
      if (!Number.isNaN(numeric)) {
        setInitialRecord((prev: any) => ({ ...prev, ret00cd_id: numeric }))
      }
    }
    setUrlParamsReady(true)
  }, [urlParamsReady, searchParams])

  return (
    <Ret00cEditorPage
      record={initialRecord}
      groupOptions={groupOptions}
      actionItems={[
        {
          key: 'back-list',
          label: '返回列表',
          icon: <ArrowLeftOutlined />,
          onClick: () => { navigate('/ret00cs') },
        },
      ]}
      submitText='保存'
      successMessage='新增成功'
      failureMessage='新增失败'
      onSubmit={async (values, { requestParams, responseParams }) => {
        await createRet00c({
          ...values,
          request_params: requestParams,
          response_params: responseParams,
        })
        reloadTree()
        navigate('/ret00cs')
      }}
    />
  )
}

export default New
